const clean = (value) => String(value ?? "").trim();

export const introArea = (details) => {
  const city = clean(details?.City);
  // The intro queries have returned the ZIP as both PostalCode and ZIP.
  const zip = clean(details?.PostalCode) || clean(details?.ZIP);
  const stateAndZip = [clean(details?.State), zip].filter(Boolean).join(" ");
  return [city, stateAndZip].filter(Boolean).join(", ");
};

// The street address stays private until the recipient accepts the introduction.
// A cancelled or not-a-fit introduction is masked by the API like a pending one.
export const isIntroAccepted = (details) =>
  (Boolean(details?.Accept_Date) || Number(details?.IsAccept) === 1) &&
  Number(details?.Not_A_Fit) !== 1 &&
  Number(details?.IsCancelled) !== 1;
